'use strict';

export default angular
  .module('maestro.directives.components.overlay', [])
  .directive('appOverlay', function() {
    return {
      restrict: 'A',
      link: (scope, element, attr) => {
        //Set position to relative so the child overlay div will be absolute positioned but bounded by the parent
        //(current element in our case) boundaries
        $(element).css('position', 'relative');

        scope.$watch(attr.appOverlay, value => {
          const existingOverlay = element.find('.ppc-loader-overlay').length > 0;
          let overlay;
          if (value) {
            if (!existingOverlay) {
              //Add element and then add class so it will appear smoothly with animation
              $(element).append('<div class="ppc-loader-overlay long-fade long-fade-out" />');
              overlay = angular.element(document.querySelector('.ppc-loader-overlay'));
              overlay.offset();
              overlay.addClass('in');
            }
          } else {
            if (existingOverlay) {
              //Remove class first so it will hide away itself smoothly with animation
              overlay = angular.element(document.querySelector('.ppc-loader-overlay'));
              overlay.addClass('out');
              //And then remove element from the DOM
              overlay.remove();
            }
          }
        });
      }
    };
  })
  .name;
